import {$http} from '@utils'
import queryString from 'query-string'
import api from '@utils/api'
export default {
    namespaced: true,
    state:{
    },
    mutations:{
    },
    actions:{
        // 新增
        async addEmpAccount ({commit},{param}) {
            const res = await $http.post(`${api.mainHost}${api.mainContentPath}/account/addEmpAccount.do`,queryString.stringify({param}),{
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            });
            return res

        },
        // 修改
        async updateEmpInfo ({commit},{param}) {
            const res = await $http.post(`${api.mainHost}${api.mainContentPath}/account/updateEmpInfo.do`,queryString.stringify({param}),{
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            });
            return res
        },
        // 员工明细
        async getEmpDetail ({commit},{param}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/account/getEmpDetail.do?${queryString.stringify({param})}`);
            return res
        },
        // 密码重置
        async resetEmpPwd ({commit},{param}) {

            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/account/resetEmpPwd.do?${queryString.stringify(param)}`);
            return res
            // if (res.code * 1 === 1) {
            //     callback&&callback()
            // } else {}
        },
    }
}